import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import React from 'react';
import { useLoginContext } from '../../../../../contexts/LoginContext';
import { NotificationProfile } from '../../../types';

export const impactLevels = new Map([
  ['All', 'All'],
  ['None', 'NoImpact'],
  ['Low', 'Low'],
  ['Medium', 'Medium'],
  ['High', 'High'],
  ['Closed', 'Closed'],
]);

interface EventTypesProps {
  included: boolean;
  impactLevel: string;
  type: {
    alerttype: string;
    name: string;
    description: string;
    eventtypes?: string;
  };
  isFirst: boolean;
}

const EventType: React.FC<EventTypesProps> = ({
  included,
  impactLevel,
  type,
  isFirst,
}) => {
  const { user, updateProfile, selectedProfileIndex } = useLoginContext();
  const selectedProfile = user?.extProfiles[selectedProfileIndex ?? 0];

  const handleCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    selectedProfile: NotificationProfile
  ) => {
    const checked = e.target.checked;
    const name = e.target.name;
    if (selectedProfile) {
      const allImpactEventTypes = selectedProfile.allImpactEventTypes;
      const eventTypeImpacts = selectedProfile.eventTypeImpacts;
      if (!checked) {
        const idx = allImpactEventTypes.indexOf(name);
        if (idx > -1) {
          allImpactEventTypes.splice(idx, 1);
        }
        delete eventTypeImpacts[name];
      } else {
        allImpactEventTypes.push(name);
      }
      selectedProfile.eventTypeImpacts = eventTypeImpacts;
      selectedProfile.allImpactEventTypes = allImpactEventTypes;
      updateProfile(selectedProfile);
    }
  };

  const handleSelectChange = (
    e: SelectChangeEvent<string>,
    selectedProfile: NotificationProfile
  ) => {
    const value = e.target.value;
    const name = e.target.name;
    const allImpactEventTypes = selectedProfile.allImpactEventTypes;
    const eventTypeImpacts = selectedProfile.eventTypeImpacts;
    if (value === 'All') {
      if (!allImpactEventTypes.includes(name)) {
        allImpactEventTypes.push(name);
      }
      if (undefined !== eventTypeImpacts[name]) {
        delete eventTypeImpacts[name];
      }
    } else if (value !== '') {
      const idx = allImpactEventTypes.indexOf(name);
      if (idx > -1) {
        allImpactEventTypes.splice(idx, 1);
      }
      eventTypeImpacts[name] = value;
    } else {
      const idx = allImpactEventTypes.indexOf(name);
      if (idx > -1) {
        allImpactEventTypes.splice(idx, 1);
      }
      delete eventTypeImpacts[name];
    }
    selectedProfile.eventTypeImpacts = eventTypeImpacts;
    selectedProfile.allImpactEventTypes = allImpactEventTypes;
    updateProfile(selectedProfile);
  };

  if (selectedProfile === undefined) {
    return null;
  } else {
    return (
      <Box sx={{ display: 'flex' }}>
        <FormControlLabel
          sx={{ flex: 0, minWidth: 125 }}
          control={
            <Checkbox
              checked={included}
              onChange={(e) => handleCheckboxChange(e, selectedProfile)}
              name={type.name}
              autoFocus={isFirst}
            />
          }
          label={type.name}
        />
        <FormControl sx={{ paddingRight: 5, flex: 1 }}>
          <Select
            size="small"
            name={type.name}
            displayEmpty
            value={impactLevel ? impactLevel : ''}
            onChange={(e) => handleSelectChange(e, selectedProfile)}
            input={<OutlinedInput />}
            renderValue={(selected) => {
              if (selected === '') {
                return <em>Select a Level</em>;
              } else {
                // Find the key that corresponds to the stored value
                const entry = Array.from(impactLevels.entries()).find(
                  ([, value]) => value === selected
                );
                return entry ? entry[0] : selected;
              }
            }}
            inputProps={{ 'aria-label': 'Without label' }}
          >
            {Array.from(impactLevels.entries()).map(([key, value]) => (
              <MenuItem key={key} value={value}>
                {key}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    );
  }
};

export default EventType;
